import React from 'react';
import SentForApprovalPage from './sent-approval/SentForApprovalPage';

const SentApprovalsPage: React.FC = () => {
  return <SentForApprovalPage />;
};

export default SentApprovalsPage;
